import { forwardRef } from 'react'

import { uiTestId } from '../../test-ids'
import type { SelectProps } from '../form/select'
import { Select } from '../form/select'

export type CountrySelectProps = {
  label?: string
} & Omit<SelectProps, 'options' | 'label'>

export const CountryCodes = ['AT', 'CH', 'DE', 'DK', 'IT', 'NL', 'LU'] as const

export type CountryCode = (typeof CountryCodes)[number]

const countryNames: Record<CountryCode, string> = {
  AT: 'Österreich',
  CH: 'Schweiz',
  DE: 'Deutschland',
  DK: 'Dänemark',
  IT: 'Italien',
  NL: 'Niederlande',
  LU: 'Luxemburg',
}

const countryOptions = [
  { value: '', label: 'Bitte wählen...' },
  ...CountryCodes.map(value => ({ value, label: countryNames[value] })),
]

export const CountrySelect = forwardRef<HTMLSelectElement, CountrySelectProps>(
  ({ label, ...rest }, ref) => (
    <Select
      ref={ref}
      options={countryOptions}
      label={label ?? 'Land'}
      data-testid={uiTestId('CountrySelect.root')}
      {...rest}
    />
  )
)

CountrySelect.displayName = 'CountrySelect'
